import { useEffect, useRef } from "react";

export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Recordar la última función callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Establecer el intervalo y limpiar al desmontar.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
